import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/oapbn`;

export const ACTION_TYPES = {
  FETCH_OAPBN_LIST: 'OAPBN/FETCH_OAPBN_LIST',
  REJECT_OAPBN: 'OAPBN/REJECT_OAPBN',
  VERIFY_OAPBN: 'OAPBN/VERIFY_OAPBN',
  RESET: 'OAPBN/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const oapbnReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_OAPBN_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.REJECT_OAPBN):
    case REQUEST(ACTION_TYPES.VERIFY_OAPBN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_OAPBN_LIST):
    case FAILURE(ACTION_TYPES.REJECT_OAPBN):
    case FAILURE(ACTION_TYPES.VERIFY_OAPBN):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_OAPBN_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.REJECT_OAPBN):
    case SUCCESS(ACTION_TYPES.VERIFY_OAPBN):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default oapbnReducer;

// ACTIONS
export const getEntities = (page, size, sort, type, name, status) => ({
  type: ACTION_TYPES.FETCH_OAPBN_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
      type: type === "" ?  undefined : type,
      name: name === "" ?  undefined : name,
      status: status === "" ?  undefined : status,
    },
  }),
});


export const rejectEntity = (entity, id, pagination, sortTable, type, name, status) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.REJECT_OAPBN,
    payload: axios.post(`${apiUrl}/${id}/reject`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  dispatch(getEntities(pagination.current-1, null, sortTable, type, name, status));
  return result;
};

export const verifyEntity = (entity, id, pagination, sortTable, type, name, status) => async dispatch => {
    const result = await dispatch({
      type: ACTION_TYPES.VERIFY_OAPBN,
      payload: axios.post(`${apiUrl}/${id}/verify`, entity),
      meta: { successMessage: `Berhasil update!` },
    });
    dispatch(getEntities(pagination.current-1, null, sortTable, type, name, status));
    return result;
  };

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
